import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";

interface DeleteChat {
  chatId: string;
  accessToken: string;
}

export const deleteChatBeAsync = async ({
  chatId,
  accessToken,
}: DeleteChat) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios(`chat/${chatId}`, {
    method: HttpRequestMethodEnum.DELETE,
    headers,
  });
  return res.data;
};
